import { useState, useEffect } from "react";
import SelezionaComprensorio from "../components/selezionacomp.js";
import { API_BASE } from "../utils/draftutils"; 

export default function VisualizzaComprensori() {
  const [listaComprensori, setListaComprensori] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetch(`${API_BASE}/api/comprensori`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Errore durante la chiamata API");
        }
        return res.json();
      })
      .then((data) => setListaComprensori(data))
      .catch(() => {
        setMessage("Errore durante il caricamento dei comprensori.");
      });
  }, []);

  return (
    <div className="p-4 w-100">
      <h2 className="mb-4">LISTA COMPRENSORI</h2>
      <hr className="my-4" />
      {message && <p className="text-danger">{message}</p>}
      <SelezionaComprensorio 
        comprensori={listaComprensori} 
        showSelectButton={false} 
      />
    </div>
  );
}
